//#region src/web-wallet-channel/utils.ts
function getClientMetadata() {
	return {
		version: "1",
		originUrl: window.location.href,
		userAgent: navigator.userAgent,
		screenResolution: `${window.screen.width}x${window.screen.height}`,
		language: navigator.language,
		platform: navigator.platform,
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		timestamp: Date.now()
	};
}
//#endregion
export { getClientMetadata };

//# sourceMappingURL=utils.mjs.map